import script from "./tax-withholding.vue?vue&type=script&lang=tsx&setup=true"
export * from "./tax-withholding.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__